import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  templateType: string;
  handleCloseModal: () => void;
};

const ChangeCouncilTemplateModalHeader: FC<Props> = ({
  templateType,
  handleCloseModal,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Header>
      <h5 className="modal-title">
        {t('ChangeTemplate')}&nbsp;
        <span className="text-muted ff-alt fs-14px text-right">
          ({t(templateType)})
        </span>
      </h5>
      <a className="close cursor-pointer" onClick={handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default ChangeCouncilTemplateModalHeader;
